import { Component, Input, OnInit } from "@angular/core";
import {
  AncillaryItem,
  AncillaryItemGroup,
} from "../../../../../model/calculation/calculationResult";
import { CalculationTableConfig } from "../../calculator-us-formData";
import { CalculatorService } from "../../../../../services/calculator.service";
import { formatAncillaryCodeName } from "../../../../../utils/stringUtils";

@Component({
  selector: "app-ancillary-item",
  templateUrl: "./ancillary-item.component.html",
  styleUrls: ["./ancillary-item.component.scss"],
})
export class AncillaryItemComponent implements OnInit {
  @Input()
  calculationTableConfig: CalculationTableConfig;

  @Input()
  displayedAncillaryItems: any[];

  @Input()
  ancillaryItemName: string;
  @Input()
  index: number;

  totalPrices: number[] = [];
  priceQuantities: Array<number | undefined> = [];

  formatAncillaryCodeName = formatAncillaryCodeName;

  constructor(public calculatorService: CalculatorService) {}

  ngOnInit(): void {}

  ngOnChanges() {
    for (let i = 0; i < this.displayedAncillaryItems.length; i++) {
      const item = this.displayedAncillaryItems[i]?.[this.index];
      if (item != undefined) {
        this.totalPrices[i] = item.totalPrice ?? 0;
        this.priceQuantities[i] =
          item.quantity === 1000 ? item.priceQuantity : undefined;
      }
    }
  }
}
